export default {
  2:'Centrebet',
  4:'Admiral',
  5:'Expekt',
  6:'Unibet / 888 / 32red',
  9:'Betshop',
  13:'Sportingbet',
  15:'Intertops',
  17:'Ladbrokes',
  20:'Oddset',
  22:'VCBet',
  26:'Interwetten',
  27:'Easybets',
  30:'bwin',
  34:'Stan James',
  37:'Fonbet',
  39:'Veikkaus',
  41:'Norsk Tipping',
  42:'William Hill',
  43:'Danske Spil',
  44:'Svenska spel',
  49:'bet-at-home',
  52:'gamebookers',
  53:'TheGreek.com',
  58:'Chance',
  59:'GWbet',
  65:'SportsTAB',
  67:'CaribSports',
  68:'Victorytip',
  70:'Nike',
  75:'Cash Point',
  76:'Stanleybet',
  83:'PinnacleSports',
  84:'Paddy Power',
  92:'STS',
  109:'BETDAQ',
  110:'Betfair',
  117:'SNAI',
  118:'Nordicbet',
  119:'BET 1128',
  126:'Bet 365',
  128:'GoldBet',
  155:'Iceland',
  158:'Boylesports',
  159:'Sazka',
  163:'Tote',
  197:'SportBet',
  212:'sportsbook.com',
  221:'skybet',
  229:'Macau Slot',
  234:'5 Dimes',
  235:'Tipsport-Sk',
  236:'BoDog',
  238:'BETCRIS',
  244:'Coral',
  245:'HK Jockey Club',
  270:'Synot TIP',
  271:'Toto',
  274:'10BET',
  275:'StarPrice',
  282:'Singbet',
  285:'IBCBET',
  287:'Victoriatip',
  291:'Betfred',
  313:'Hititbet',
  314:'Matchbook',
  327:'sbobet.com',
  332:'Betsafe',
  333:'Milenium',
  334:'TotoSi',
  336:'myBet.com',
  340:'Betway',
  342:'Betsson Sportsbook',
  345:'Betstar',
  355:'Doxxbet',
  357:'MeridianBet',
  359:'DiamondSportsBook',
  360:'BetGun.com',
  363:'Tipico',
  365:'188bet',
  378:'bookmaker.eu',
  380:'PartyBets',
  385:'Mansion88.com',
  388:'Eurobet.it',
  395:'BetClick',
  399:'Bet3000',
  401:'BetUS',
  402:'Singapore Pools',
  403:'intralot',
  406:'Efbet',
  413:'better.it',
  420:'Miseojeu',
  421:'gioco digitale',
  424:'e-stave',
  426:'LUXBET.com',
  431:'LEON',
  434:'12bet.com',
  449:'bwin.it',
  451:'Pamestihima',
  452:'iddaa',
  453:'Startip',
  462:'Titanbet',
  466:'BetClic.it',
  468:'Unibet.it',
  479:'Scommettendo',
  483:'Bookie Bob',
  487:'Hrvatska Lutrija',
  488:'SuperSport',
  489:'iFortuna.eu',
  491:'Tattsbet',
  492:'Novibet',
  493:'Parionsweb',
  495:'betclick.fr',
  500:'Offsidebet',
  501:'BetAdria',
  502:'youwin',
  504:'BetOnline',
  506:'youwager.com',
  527:'iFortuna.sk',
  528:'Betfair AUS',
  529:'sportsbet.com.au',
  532:'Dafabet',
  535:'Flemington Sportsbet',
  538:'Goalbet',
  539:'Marathonbet',
  540:'betcity',
  541:'parimatch',
  548:'iziplay',
  550:'comeon!',
  551:'Betsonic',
  552:'isibet',
  558:'Millenniumbet',
  559:'Paddypower.it',
  560:'138sungame',
  562:'Balkanbet',
  563:'tomwaterhouse',
  564:'Sporttery',
  565:'Olimpbet',
  567:'Bovada',
  568:'williamhill.it',
  570:'Cirsa',
  571:'betISN',
  573:'Caliente',
  574:'TonyBet',
  575:'smarkets',
  576:'Betflag',
  577:'Sisal Matchpoint',
  579:'noxwin',
  580:'fun88',
  581:'bodog88',
  582:'RB88',
  583:'williamhill.es',
  584:'interwetten.es',
  585:'bwin.es',
  589:'ApolloBET',
  590:'Setantabet',
  592:'PAF.es',
  594:'winner',
  595:'138',
  598:'bet-at-home.it',
  600:'Tipico.it',
  601:'sjbet',
  604:'888sport',
  605:'Bluebet.it',
  607:'Gamenet.it',
  608:'merkur-win.it',
  609:'SportYes.it',
  610:'agile.it',
  611:'betitaly.it',
  612:'domusbet.it',
  613:'Betfair SB',
  615:'stoiximan',
  616:'leaderbet',
  618:'Championsbet',
  621:'GameLux.it',
  622:'Rivalo.com',
  624:'PinnBet',
  625:'Betaland',
  627:'PlanetWin365',
  628:'MozzartBet',
  630:'SuperLenny',
  631:'NetBet',
  632:'Ladbrokes.com.au',
  634:'Spreadex',
  635:'Guts',
  636:'Bookmaker.com.au',
  639:'Fast Lane Betting',
  640:'BetRebels',
  641:'Betbright',
  642:'GR88',
  644:'GTbets',
  645:'Gazzabet.it',
  646:'NetBet.it',
  648:'FavBet',
  649:'1xbet',
  653:'Bet8',
  654:'Vernons',
  655:'Tempobet',
  656:'Aycons.it',
  657:'2WinBet',
  658:'Bet9ja',
  659:'Favourit',
  660:'naija4win',
  661:'CrownBet',
  662:'Merrybet',
  663:'NairaBet.com',
  664:'1960bet',
  665:'GiochiTelematici',
  666:'Senibet',
  667:'Tuttur.com',
  669:'Pokerstars',
  670:'WilliamHill.com.au',
  672:'MaxBet',
  673:'ScommesseItalia',
  676:'Bet25',
  680:'SureBet247',
  684:'Luckia',
  685:'BetSport7',
  689:'Mobilbet',
  690:'tab.co.nz',
  691:'Coolbet',
  692:'Youbet.it'
}



/** WEBPACK FOOTER **
 ** ./src/config/allBookmakers.js
 **/